import React, { useMemo } from "react";
import { Row, Col } from "antd";
import ReactEchart from "../../../../../../molecules/ReactEchart";

const StackedSingleBarChart = React.memo((props: any) => {
  const { ageBuckets } = props;

  const options = useMemo<any | null>(
    () => ({
      xAxis: { type: "category", show: false, data: [""] },
      yAxis: { type: "value", show: false },
      grid: { left: "0%", right: "20%", top: "5%", bottom: "5%" },
      tooltip: { show: true },
      legend: {
        z: 99999,
        show: true,
        orient: "vertical",
        top: "center",
        right: 20,
        textStyle: {
          overflow: "break",
        },
      },

      // 🎨 color array for the chart
      color: [
        "#0D2F47",
        "#4C708D",
        "#FF8C8C",
        "#4DA6FF",
        "#8cbfe0ff",
        "#808d95",
      ],

      series: ageBuckets?.map((item) => ({
        name: item.label,
        type: "bar",
        stack: "total",
        data: [item.count],
        barWidth: "15%",
        barGap: "10%",
        barMinHeight: 5, // 👈 ensures bar is at least 5px tall
        itemStyle: {
          color: item.color, // still supports per-item color
          borderRadius: [8, 8, 8, 8],
          borderWidth: 5,
          borderColor: "#ffffff",
        },
        label: {
          show: true,
          formatter: (params) => (params.value > 0 ? params.value : ""),
        },
        barCategoryGap: "0%",
      })),
    }),
    [ageBuckets]
  );

  return (
    <Row style={{ display: "flex", justifyContent: "center" }} gutter={24}>
      <Col flex="1" style={{ height: `${200 * 2}px` }}>
        <ReactEchart options={options} />
      </Col>
    </Row>
  );
});

export default StackedSingleBarChart;
